// extracted by mini-css-extract-plugin
export default {"navWrapper":"BottomNav_navWrapper__DiY4R","navItem":"BottomNav_navItem__jt9BQ","active":"BottomNav_active__+6JCG"};